import { render } from "./AddFilleulField.vue?vue&type=template&id=3f8d3f70"
import script from "./AddFilleulField.vue?vue&type=script&lang=js"
export * from "./AddFilleulField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__